const normalizeTraceIdFromAmznHeader = (traceHeaderValue: string): string => {
  const rootMatch = traceHeaderValue.match(/Root=([^;]+)/i);
  if (rootMatch?.[1]) {
    return rootMatch[1];
  }

  return traceHeaderValue;
};

const getHeaderValue = (headers: Record<string, string> | undefined, headerName: string): string => {
  if (!headers) {
    return "";
  }

  const headerValue = headers[headerName];
  if (typeof headerValue === "string" && headerValue.length > 0) {
    return headerValue;
  }

  const targetName = headerName.toLowerCase();
  for (const [key, value] of Object.entries(headers)) {
    if (key.toLowerCase() === targetName && typeof value === "string" && value.length > 0) {
      return value;
    }
  }

  return "";
};

export const resolveTraceIdFromHeaders = (headers: Record<string, string> | undefined): string => {
  const traceId = getHeaderValue(headers, "x-trace-id");
  if (traceId) {
    return traceId;
  }

  const amznTraceId = getHeaderValue(headers, "x-amzn-trace-id");
  if (!amznTraceId) {
    return "";
  }

  return normalizeTraceIdFromAmznHeader(amznTraceId);
};
